var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRating = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C15.3063 9 16.4175 9.83485 16.8293 11.0001L22 11C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13L16.829 13.0009C16.4169 14.1656 15.3059 15 14 15C12.6941 15 11.5831 14.1656 11.171 13.0009L2 13C1.44772 13 1 12.5523 1 12C1 11.4872 1.38604 11.0645 1.88338 11.0067L2 11L11.1707 11.0001C11.5825 9.83485 12.6937 9 14 9ZM14 11C13.4477 11 13 11.4477 13 12C13 12.5523 13.4477 13 14 13C14.5523 13 15 12.5523 15 12C15 11.4477 14.5523 11 14 11Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRating);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconRating.ba63540ffc42de2f47b569ebe165bba5.svg";